module.exports = __webpack_public_path__ + "static/media/hands_03.03ab83cb.svg";